export default __webpack_public_path__ + "static/media/ic_edit.8e8ce8d0.svg";